import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';

const { createSliderWithTooltip } = Slider;
const SliderTooltip = createSliderWithTooltip(Slider)

export const CustomSlider = ({extraClasses, label, handler, value, ...props}) => {
    return (
        <div className={`formInput ${extraClasses || ''}`}>
            <label> {label} </label>
            <SliderTooltip value={value} onChange={handler} {...props} />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/customModules/Common/form/Slider.js